import { LocaleId } from '../../models/locale.model';

export enum ReportViews {
  summary = 1,
  condensed,
  compare,
  detail,
  presentation,
  comparison,
  condensedDynamic,
  table,
  presentationDynamic,
  summaryDynamic,
  properties,
}

export const TEMPLATE_ASSOCIATIONS = {
  28: [9, 10],
  29: [9, 10],
};

export const LOCALE_VIEW_TEMPLATE_ASSOCIATIONS = {
  28: [{ 9: [16, 17, 18] }, { 10: [19, 20, 21] }],
  29: [{ 9: [16, 17, 22] }, { 10: [19, 20, 21] }],
};

export const contactsSectionRequiredCountries = [
  LocaleId.PolandEnglish,
  LocaleId.PolandPolish,
  LocaleId.FinlandEnglish,
  LocaleId.FinlandFinnish,
  LocaleId.SwedenEnglish,
  LocaleId.SwedenSwedish,
  LocaleId.ItalyEnglish,
  LocaleId.ItalyItalian,
  LocaleId.NorwayEnglish,
  LocaleId.NorwayNorwegian,
  LocaleId.NlEnglish,
  LocaleId.NlDutch,
];
